<template>
  <el-card
    v-loading="loading"
    class="card-container"
    shadow="never"
  >
    <el-row
      v-if="objectInfo"
      slot="header"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <h3 class="m-0">
        {{ objectInfo.extra.name }}
      </h3>
      <div>
        <el-switch
          v-model="isPublish"
          class="ml-m"
          active-text="Publish"
          @change="handlePublish"
        />
      </div>
    </el-row>
    <el-row
      v-if="objectInfo"
      :gutter="12"
    >
      <el-col
        :lg="24"
        :span="24"
        class="mb-m"
      >
        <ObjectInfo
          :object="objectInfo"
          :all-configs="allConfigs"
          @save="handleSave"
        />
      </el-col>
      <el-col
        :lg="24"
        :span="24"
        class="mb-m"
      >
        <ObjectFields
          :key="JSON.stringify(objectInfo.extra.fields)"
          :object="objectInfo"
          :all-configs="allConfigs"
          @save="handleSave"
        />
      </el-col>
      <div v-if="objectInfo.type !== 'categories'">
        <el-col
          :lg="24"
          :span="24"
          class="mb-m"
        >
          <ObjectGroups
            :object="objectInfo"
            @save="handleSave"
          />
        </el-col>
        <el-col
          :lg="24"
          :span="24"
          class="h-100 mb-m"
        >
          <ObjectModules
            :object="objectInfo"
            @save="handleSave"
          />
        </el-col>
        <el-col
          :lg="24"
          :span="24"
          class="h-100 mb-m"
        >
          <ObjectContracts
            :object="objectInfo"
            @save="handleSave"
          />
        </el-col>
        <el-col
          :lg="24"
          :span="24"
          class="h-100 mb-m"
        >
          <ObjectActions
            :object="objectInfo"
            @save="handleSave"
          />
        </el-col>
        <el-col
          :lg="24"
          :span="24"
          class="h-100 mb-m"
        >
          <ObjectMapping
            :object="objectInfo"
            @save="handleSave"
          />
        </el-col>
      </div>
    </el-row>
  </el-card>
</template>

<script>
import ObjectInfo from "./components/detail/ObjectInfo";
import ObjectFields from "./components/detail/ObjectFields";
import ObjectGroups from "./components/detail/ObjectGroups";
import ObjectModules from "./components/detail/ObjectModules";
import ObjectContracts from "./components/detail/ObjectContracts";
import ObjectActions from "./components/detail/ObjectActions";
import ObjectMapping from "./components/detail/ObjectMapping";

import configServices from "@/services/config";

export default {
  name: "ConfigDetail",
  components: {
    ObjectInfo,
    ObjectFields,
    ObjectGroups,
    ObjectModules,
    ObjectContracts,
    ObjectActions,
    ObjectMapping,
  },
  data() {
    return {
      loading: false,
      objectInfo: null,
      isPublish: false,
      allConfigs: [],
    };
  },
  computed: {
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    getAllConfigs(organizationId) {
      configServices.list({
        offset: 0,
        limit: 999,
        filters: {
          'extra.organization_id': organizationId
        },
      })
        .then((response) => {
          this.allConfigs = response.items;
        })
        .catch(() => {
          this.allConfigs = [];
        })
    },
    loadData() {
      this.loading = true;
      configServices
        .fetchById(this.$route.params.id)
        .then((response) => {
          this.objectInfo = response;
          this.isPublish = response.extra?.is_publish || false;
          this.getAllConfigs(response.extra.organization_id);
          this.loading = false;
        })
        .catch(() => {
          this.$router.push({ name: "Config" });
        });
    },
    handlePublish(value) {
      this.handleSave(
        {
          payload: { is_publish: value },
          success: () => {},
          error: () => {},
        },
        this.getAllConfigs(this.objectInfo?.extra?.organization_id)
      );
    },
    handleSave(
      data = { payload: {}, success: () => {}, error: () => {} },
      callback = () => {}
    ) {
      const payload = {
        ...this.objectInfo,
        extra: {
          ...this.objectInfo.extra,
          ...data.payload,
        },
      };
      configServices
        .update(payload)
        .then(async () => {
          data.success();
          this.loadData();
          this.getAllConfigs(this.objectInfo?.extra?.organization_id);
          setTimeout(() => {
            callback();
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          data?.error();
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
